import { useLocation } from 'react-router-dom';
import { useState } from 'react';

const BuyProductPage = () => {
  const location = useLocation();
  const product = location.state?.product;

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    phone: '',
    quantity: 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    console.log('Form submitted:', formData, product);
    alert('Thank you for your order!');
  };

  if (!product) {
    return (
      <div className="text-center mt-24 text-gray-500 text-lg tracking-wide">
        Product not found.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f9f9f9] px-6 py-20 flex justify-center items-start">
      <div className="w-full max-w-6xl bg-white rounded-[40px] p-10 md:p-16 grid grid-cols-1 md:grid-cols-2 gap-16">
        {/* Left side */}
        <div className="flex flex-col justify-start">
          <div>
            
            <h2 className="mt-3 text-3xl font-bold text-black">{product.name}</h2>
            <p className="mt-2 text-gray-500 text-base leading-relaxed">{product.description}</p>
          </div>

          <div className="mt-10 rounded-xl overflow-hidden flex justify-center items-center max-h-[300px]">
            <img
              src={product.image}
              alt={product.name}
              className="object-contain max-h-[280px] w-full"
            />
          </div>
        </div>

        {/* Right side - Form */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          className="space-y-6"
        >
          {[
            { label: 'Full Name', name: 'name', type: 'text' },
            { label: 'Email Address', name: 'email', type: 'email' },
            { label: 'Shipping Address', name: 'address', type: 'text' },
            { label: 'Phone Number', name: 'phone', type: 'tel' },
            { label: 'Quantity', name: 'quantity', type: 'number' },
          ].map(({ label, name, type }) => (
            <div key={name}>
              <label htmlFor={name} className="block mb-2 text-sm font-medium text-gray-800">
                {label}
              </label>
              <input
                id={name}
                type={type}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                required
                min={name === 'quantity' ? 1 : undefined}
                className="w-full px-4 py-3 text-sm border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-gray-900 transition"
              />
            </div>
          ))}

          <p className="text-xs text-gray-500 mt-2">
            * We will contact you after submission to confirm your order.
          </p>

          <div className="flex justify-between pt-4">
            <button
              type="button"
              onClick={() => window.history.back()}
              className="text-sm text-gray-700 hover:text-black transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-black text-white text-sm font-medium px-6 py-3 rounded-full hover:bg-gray-800 transition"
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BuyProductPage;
